<template>
  <div>
    <work-order-view-formulation-section/>
<!--    <vx-card>-->
<!--    <div class="vx-row" id="rm-order-details-view">-->
<!--        <div class="vx-col w-1/3 h-full">-->
<!--            <div class="vx-row">-->
<!--              <div class="vx-col w-full">-->
<!--                <label class="text-sm opacity-100 text-bold">Select Production Line</label>-->
<!--                <v-select :clearable="true" :dir="$vs.rtl ? 'rtl' : 'ltr'" label="production_line_code"-->
<!--                          :options="live_production_lines"-->
<!--                          placeholder="" v-model="selected_production_line">-->
<!--                  <template v-slot:option="option">-->
<!--                    <span>{{option.production_line_code}} - {{option.production_line_name}} </span>-->
<!--                  </template>-->
<!--                </v-select>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="vx-row mt-8" v-if="selected_production_line">-->
<!--              <div class="vx-col lg:w-full w-full">-->
<!--                <vs-table noDataText="">-->
<!--                  <template>-->
<!--                    <vs-tr>-->
<!--                      <vs-td class="">Line Code</vs-td>-->
<!--                      <vs-td class="font-bold text-primary">{{selected_production_line.production_line_code}}</vs-td>-->
<!--                    </vs-tr>-->

<!--                    <vs-tr>-->
<!--                      <vs-td class="">Line Name</vs-td>-->
<!--                      <vs-td class=" font-bold text-primary">{{selected_production_line.production_line_name}}</vs-td>-->
<!--                    </vs-tr>-->

<!--                    <vs-tr>-->
<!--                      <vs-td class="">Type</vs-td>-->
<!--                      <vs-td class=" font-bold text-primary">{{selected_production_line.type}}</vs-td>-->
<!--                    </vs-tr>-->

<!--                    <vs-tr>-->
<!--                      <vs-td class="">Max Capacity (L)</vs-td>-->
<!--                      <vs-td class=" font-bold text-primary">{{selected_production_line.max_capacity_ltr}}</vs-td>-->
<!--                    </vs-tr>-->

<!--                    <vs-tr>-->
<!--                      <vs-td class="">Max Capacity (KG)</vs-td>-->
<!--                      <vs-td class=" font-bold text-primary">{{selected_production_line.max_capacity_kg}}</vs-td>-->
<!--                    </vs-tr>-->

<!--                    <vs-tr>-->
<!--                      <vs-td class="">Clean Time (Mins)</vs-td>-->
<!--                      <vs-td class=" font-bold text-primary">{{selected_production_line.clean_time_between_uses}}</vs-td>-->
<!--                    </vs-tr>-->

<!--                    <vs-tr>-->
<!--                      <vs-td class="">Description</vs-td>-->
<!--                      <vs-td class=" font-bold text-primary">{{selected_production_line.description}}</vs-td>-->
<!--                    </vs-tr>-->

<!--                  </template>-->
<!--                </vs-table>-->
<!--              </div>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="vx-col w-2/3 h-full" >-->
<!--            <ValidationObserver ref="form" v-slot="{ handleSubmit }">-->
<!--              <form id="popup" @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">-->
<!--                <div id="work-order-right-section" class="vx-row">-->
<!--                  <div class="vx-col w-full">-->
<!--                    <label class="text-sm opacity-100 text-bold">Select Formulation</label>-->
<!--                    <v-select :disabled="!selected_production_line" v-on:input="fetchOrderFormulationItems()" :clearable="true" :dir="$vs.rtl ? 'rtl' : 'ltr'" label="formulation_code"-->
<!--                              :options="order_formulations_list"-->
<!--                              placeholder="" v-model="selected_formulation">-->
<!--                      <template v-slot:option="option">-->
<!--                        <span>{{option.formulation_code}} <br>{{option.name}} <br>{{option.formulation_type}} </span>-->
<!--                      </template>-->
<!--                    </v-select>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <vs-alert v-if="is_exceed" active="true" class="mt-4" color="danger" >-->
<!--                  The total quantity of selected items exceeds the maximum capacity of the product line-->
<!--                </vs-alert>-->
<!--                <div class="vx-row mt-8">-->
<!--                  <div class="vx-col lg:w-full w-full">-->
<!--                    <vs-table-->
<!--                      :hoverFlat="true"-->
<!--                      stripe-->
<!--                      :data="order_formulations_items">-->

<!--                      <template slot="thead">-->
<!--                        <vs-th >Product Order Code</vs-th>-->
<!--                        <vs-th >Pending Manufacturing Quantity (KG)</vs-th>-->
<!--                        <vs-th ></vs-th>-->
<!--                      </template>-->

<!--                      <template slot-scope="{data}">-->
<!--                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">-->
<!--                          <vs-td :data="data[indextr].product_order_code">-->
<!--                            {{ data[indextr].product_order_code }}-->
<!--                          </vs-td>-->
<!--                          <vs-td :data="data[indextr].pending_manufacture_quantity">-->
<!--                            {{ data[indextr].pending_manufacture_quantity }}-->
<!--                          </vs-td>-->
<!--                          <vs-td :data="data[indextr].pending_manufacture_quantity">-->
<!--                            <ValidationProvider :vid="indextr + 'quantity' " :name="indextr + 'quantity'" :rules="'maxoq:'+data[indextr].pending_manufacture_quantity" v-slot="{ errors }">-->
<!--&lt;!&ndash;                              <vs-input v-on:input="onInputQty()" type="text" v-model="data[indextr].quantity" class="w-full"&ndash;&gt;-->
<!--&lt;!&ndash;                                        :name="'quantity'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>&ndash;&gt;-->

<!--                              <vs-input-number-->
<!--                                v-on:input="onInputQty()"-->
<!--                                label="Selected Quantity:"-->
<!--                                min="0" :max="data[indextr].pending_manufacture_quantity"-->
<!--                                v-model="data[indextr].quantity"/>-->
<!--                            </ValidationProvider>-->
<!--                          </vs-td>-->
<!--                        </vs-tr>-->
<!--                      </template>-->
<!--                    </vs-table>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="vx-row mb-3 mt-4">-->
<!--                  <div class="vx-col w-full">-->
<!--                    <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">-->
<!--                      <small class="label">Note</small>-->
<!--                      <vs-textarea class="mb-0" v-model="note" height="150px" />-->
<!--                      <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>-->
<!--                    </ValidationProvider>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="flex flex-wrap items-center justify-end mt-8">-->
<!--                  <vs-button :disabled="is_exceed" button="submit" class="ml-auto mt-2">Create</vs-button>-->
<!--                </div>-->
<!--              </form>-->
<!--            </ValidationObserver>-->
<!--        </div>-->
<!--    </div>-->
<!--    </vx-card>-->
  </div>


</template>

<script>
  import vSelect from "vue-select";
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const ManufacturingRepository = RepositoryFactory.get('manufacturing');
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import WorkOrderViewFormulationSection from './WorkOrderViewFormulationSection.vue'


  export default {
    name: "WorkOrderCreate",
    data() {
      return {
        live_production_lines: [],
        order_formulations_list: [],
        selected_production_line: null,
        selected_formulation: {},
        order_formulations_items: [],
        note: '',
        is_exceed: false
      }
    },
    components: {
      'v-select': vSelect,
      WorkOrderViewFormulationSection
    },
    mixins : [SuccessMessage, ErrorMessages],
    async mounted() {
      // await this.fetchLiveProductionLines()
      // await this.fetchOrderFormulations()
    },
    methods: {
      // async fetchLiveProductionLines() {
      //   try {
      //     const {data} = await ManufacturingRepository.getLiveProductionLineList(1, '', 50);
      //     this.live_production_lines = data.data
      //   } catch (e) {
      //   }
      // },
      // async fetchOrderFormulations() {
      //   await this.$vs.loading({
      //     container: '#work-order-right-section',
      //     scale: 0.45
      //   })
      //   try {
      //     const {data} = await ManufacturingRepository.getFormulationsOrderList();
      //     this.order_formulations_list = data.data
      //   } catch (e) {
      //   }
      //   this.$vs.loading.close('#work-order-right-section > .con-vs-loading')
      // },
      async fetchOrderFormulationItems() {
        await this.$vs.loading({
          container: '#work-order-right-section',
          scale: 0.45
        })
        try {
          const {data} = await ManufacturingRepository.getFormulationsOrderItems(this.selected_formulation.id);
          this.order_formulations_items = data.data.map((n) => {
            n.quantity = 0
            n.pending_manufacture_quantity = Number(n.pending_manufacture_quantity)
            return n
          })
        } catch (e) {
        }
        this.$vs.loading.close('#work-order-right-section > .con-vs-loading')
      },

      //create work order
      async onClickSubmit() {
        await this.$vs.loading({
          container: '#work-order-right-section',
          scale: 0.45
        })
        try {
          const formulation_order_item_ids =  this.order_formulations_items.map((n) => {
            if (Number(n.quantity) > 0) {
              return {id: n.id, quantity: n.quantity}
            }
          }).filter((n) => {
            return n !== undefined;
          })

          let payload = {
            production_line_id: this.selected_production_line.id,
            formulation_id: this.selected_formulation.id,
            formulation_order_item_ids,
            note: this.note
          }
          await ManufacturingRepository.createWorkOrder(payload);
          this.showSuccessMessage('Work order create successfully')
          this.$router.push({path: `/pages/manufacturing/work-orders`})

        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#work-order-right-section > .con-vs-loading')

      },
      onInputQty() {
        const production_line_total_quantity = this.selected_production_line.max_capacity_kg
        const total_selected_item_quantity = this.order_formulations_items.filter((m) => !!m.quantity).reduce(function(acc, val) { return acc + Number(val.quantity); }, 0)
        if(Number(total_selected_item_quantity) > Number(production_line_total_quantity)) {
          this.is_exceed = true
        } else {
          this.is_exceed = false
        }
      }
    }
  }
</script>

<style scoped>

</style>
